import { render, staticRenderFns } from "./csgAdminIndex.vue?vue&type=template&id=51b9b53a&scoped=true"
import script from "./csgAdminIndex.vue?vue&type=script&lang=js"
export * from "./csgAdminIndex.vue?vue&type=script&lang=js"
import style0 from "./csgAdminIndex.vue?vue&type=style&index=0&id=51b9b53a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b9b53a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b9b53a')) {
      api.createRecord('51b9b53a', component.options)
    } else {
      api.reload('51b9b53a', component.options)
    }
    module.hot.accept("./csgAdminIndex.vue?vue&type=template&id=51b9b53a&scoped=true", function () {
      api.rerender('51b9b53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/online/csg/csgAdminIndex.vue"
export default component.exports